import {videoPlay} from '../features/video-play';
import {register} from '../vendor/theme-scripts/theme-sections';

register('featured-video', videoPlay);
